import React from 'react';
import ReactModal from 'react-modal';
import { createModal } from 'react-modal-promise';

const UserPaymentMethodDeleteModal = ({ open, close, lastFour }) => (
  <ReactModal
    appElement={document.getElementById('root')}
    isOpen={open}
    contentLabel="Minimal Modal Example"
    portalClassName="AdjustmentCreditPortal"
    overlayClassName="AdjustmentCreditModal__Overlay"
    className="AdjustmentCreditModal__Content"
  >
    <div className="modal-header">
      <span className="close" onClick={() => close(false)}>
        &times;
      </span>
      <h2>Delete this card: *{lastFour} </h2>
    </div>
    <div className="modal-body">
      <p>Are you sure you want to delete the payment method?</p>
    </div>
    <div className="modal-footer">
      <button className={'btn btn-primary'} onClick={() => close(true)}>
        Delete
      </button>
      <button className={'btn'} onClick={() => close(false)}>
        Cancel
      </button>
    </div>
  </ReactModal>
);

export default createModal(UserPaymentMethodDeleteModal);
